var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "flex-grow-1" },
    [
      _c("v-card-title", { domProps: { textContent: _vm._s(_vm.subtitle) } }),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-list",
            {
              staticStyle: { "overflow-y": "auto" },
              attrs: { height: _vm.listHeight }
            },
            _vm._l(_vm.messages, function(item, i) {
              return _c(
                "v-list-item",
                { key: i },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c("v-icon", {
                        domProps: {
                          textContent: _vm._s(_vm.getIcon(item.type))
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", {
                        domProps: { textContent: _vm._s(item.text) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-action",
                    [
                      _c("v-icon", {
                        domProps: { textContent: _vm._s("mdi-close") },
                        on: {
                          click: function($event) {
                            return _vm.$emit("delete", item)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }